import z from 'zod'

export const MunicipalityResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
})

export const MunicipalityListResponseSchema = MunicipalityResponseSchema.array()

export type MunicipalityResponse = z.infer<typeof MunicipalityResponseSchema>
export type MunicipalityListResponse = z.infer<typeof MunicipalityListResponseSchema>
